<template>
  <div class="toast-stack" data-testid="toast-stack">
    <v-snackbar
      v-for="snackbar in visibleSnacks"
      :key="snackbar.id"
      v-model="snackbar.showing"
      class="toast-snackbar csnackbars pa-0 snackbar"
      min-height="0"
      min-width="0"
      elevation="0"
      :timeout="snackbar.time"
      data-testid="toast"
    >
      <div
        class="toast"
        :class="`toast--${snackbar.type}`"
        data-testid="toast__card"
      >
        <div class="toast__content">
          <div
            class="toast__icon-wrap"
            :class="`toast__icon-wrap--${snackbar.type}`"
            data-testid="toast__icon"
          >
            <v-icon size="16" color="white">
              {{ getToastIcon(snackbar.type) }}
            </v-icon>
          </div>

          <span class="toast__message" data-testid="toast__message">
            {{ snackbar.text }}
          </span>

          <button
            v-if="snackbar.actionLabel"
            type="button"
            class="toast__action"
            :data-testid="snackbar.actionPayload?.testId || 'toast__action-btn'"
            @click="onAction(snackbar)"
          >
            {{ snackbar.actionLabel }}
          </button>
        </div>

        <div class="toast__progress-track" data-testid="toast__progress-track">
          <div
            class="toast__progress-bar"
            :class="`toast__progress-bar--${snackbar.type}`"
            :style="{ animationDuration: `${getToastDuration(snackbar)}ms` }"
            data-testid="toast__progress-bar"
          />
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import './ToastStack.scss';
import constants from '@/plugins/constants';

const TOAST_ICONS = {
  success: 'mdi-check',
  error: 'mdi-close',
  warning: 'mdi-alert-outline',
  info: 'mdi-information-outline',
};

const DEFAULT_TOAST_DURATION_MS = constants.SNACKBAR.DEFAULT_DURATION_MS;

export default {
  name: 'ToastStack',
  computed: {
    visibleSnacks() {
      return (this.$store.state.snackMultValue || []).filter((snack) => snack.showing);
    },
  },
  methods: {
    getToastIcon(type) {
      return TOAST_ICONS[type] || TOAST_ICONS.info;
    },
    getToastDuration(snackbar) {
      const duration = Number(snackbar?.time);
      return duration > 0 ? duration : DEFAULT_TOAST_DURATION_MS;
    },
    onAction(snackbar) {
      this.$emit('action', snackbar);
    },
  },
};
</script>
